<!--
    * 订单查询 
    * @author 未知 
    * @created 2021-05-14 
-->
<template>
	<div class="st-main-content">
		<common-search-form ref="commonSearch" :formOptions="formOptions" @onSearch="onSearch"></common-search-form>
		<div class="data-table-box">
			<common-table ref="CommonTableRef" :tableColumns="tableColumns" :data="dataList" :showPage="togglePage"
				:loading="loading" :pageConfig="pageConfig" @selectionChange="selectionChange"
				@currentChange="currentChange" @sizeChange="sizeChange" :bottomHandleArr="bottomHandleArr">
			</common-table>
		</div>

		<el-dialog title="选择指派的认证人员" :visible.sync="dialogVisible" :modal-append-to-body="false" :append-to-body="true"
			width="900px" center>
			<div class="dlalog-body" style="height: 50vh">
				<common-search-form ref="dialogSearch" :formOptions="dialogFormOptions" @onSearch="onDialogSearch">
				</common-search-form>
				<common-table ref="dialogCommonTableRef" max-height="40vh" :tableColumns="dialogTableColumns"
					:data="dialogDataList" :showPage="dialogTogglePage" :loading="dialogLoading"
					:pageConfig="dialogPageConfig" wrapperClassName="dialog-wrapper"
					@currentChange="dialogCurrentChange" @selectionChange="dialogSelectionChange"
					@sizeChange="dialogSizeChange">
					<template v-slot:operate="{row}">
						<div>这是操作行</div>
					</template>
				</common-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="saveAssign()">保 存</el-button>
			</div>
		</el-dialog>
		<!-- 预览大图的组件 -->
		<!-- <preview-img
            :previewPath="previewPath"
            :toggleImg="toggleImg"
            @close="toggleImg = false"
        ></preview-img> -->

		<!-- 发货 -- 填写物流信息 -->
		<el-dialog title="填写物流信息" :visible.sync="showEditShipping" width="600px" center :close-on-click-modal="false">
			<el-form v-if="showEditShipping" :model="editShipingForm" ref="editShipingForm"
				:rules="editShipingFormRule">
				<el-form-item label="快递名称" prop="logisticsCompanyName">
					<el-input v-model="editShipingForm.logisticsCompanyName" placeholder="请输入快递名称"></el-input>
				</el-form-item>
				<el-form-item label="快递单号" prop="logisticsOrderNo">
					<el-input v-model="editShipingForm.logisticsOrderNo" placeholder="请输入快递单号"></el-input>
				</el-form-item>

				<el-form-item style="text-align:right">
					<el-button @click="closeEditShipping">取消</el-button>
					<el-button type="primary" @click="submitEditShipping">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!-- 填写取消订单的原因 -->
		<el-dialog title="取消订单" :visible.sync="showReasonDialog" width="600px" center :close-on-click-modal="false">
			<el-form v-if="showReasonDialog" :model="cancelOrderForm" ref="cancelOrderForm" :rules="cancelOrderRule">
				<el-form-item label="取消订单的原因" prop="cancelReason">
					<el-input v-model="cancelOrderForm.cancelReason" placeholder="请输入取消订单的原因"></el-input>
				</el-form-item>
				<el-form-item style="text-align:right">
					<el-button @click="closeCancelReason">取消</el-button>
					<el-button type="primary" @click="submitCancelReason">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<!-- 退款审核的弹窗 showRefundAuditDialog -->
		<el-dialog title="取消订单" :visible.sync="showRefundAuditDialog" width="600px" center
			:close-on-click-modal="false">
			<el-form v-if="showRefundAuditDialog" :model="refundAuditForm" ref="refundAuditForm"
				:rules="refundAuditFormRule">
				-一个单选组件-
				<el-form-item label="审核结果" prop="">
					<el-radio-group v-model="refundAuditForm.reviewerState">
						<el-radio :label="1">通过</el-radio>
						<el-radio :label="2">不通过</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item v-if="refundAuditForm.reviewerState == 2" label="请输入审核不通过的原因" prop="refuseReason">
					<el-input type="textarea" v-model="refundAuditForm.refuseReason" placeholder="请输入审核不通过的原因">
					</el-input>
				</el-form-item>
				<el-form-item style="text-align:right">
					<el-button @click="closeRefundAudit">取消</el-button>
					<el-button type="primary" @click="submitRefundAudit">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>
<script>
	// import { CodeToText, cityJson } from "@/assets/common/city.js";
	import {
		CodeToText,
		onlycityJson
	} from "@/assets/common/city.js";
	let onlycityJsonCopy = JSON.parse(JSON.stringify(onlycityJson));
	export default {
		name: "NoticeSetting",
		props: [],
		data() {
			return {
				orderStatesTypes: [],
				togglePage: false,
				bottomHandleArr: [{
					label: "导出",
					type: "success",
					handler: () => this.comonExport()
				}],

				loading: false,
				searchParams: {},
				pageConfig: {
					total: 0,
					pageSize: 100,
					currentPage: 1,
					layout: "total, sizes,prev, pager, next"
				},
				formOptions: [{
						label: "下单时间",
						prop: "createTimeArr",
						element: "el-date-picker",
						type: "datetimerange",
						valueFormat: "timestamp"
						// valueFormat: "yyyy-MM:dd hh:mm:ss"
						// initDateBefore: 0
					},
					{
						label: "订单号",
						prop: "orderNo",
						element: "el-input"
					},

					{
						label: "订单状态",
						prop: "orderStates",
						element: "el-select",
						options: [{
								value: 0,
								label: "待支付"
							},
							{
								value: 1,
								label: "待发货"
							},
							{
								value: 2,
								label: "待收货"
							},
							{
								value: 3,
								label: "已完成"
							},
							{
								value: 4,
								label: "已取消"
							},
							{
								value: 5,
								label: "已退款"
							},
							{
								value: 100,
								label: "已作废"
							},
							{
								value: 101,
								label: "已删除"
							},

						],

					},
				],
				tableColumns: [{
						title: "序号",
						index: true,
						fixed: "left"
					},
					{
						title: "操作",
						width: 200,
						operate: true,
						setBtns: (row, index) => {
							let btns = [];
							// 且超时的订单不予取消 -- flag 为false表示超时
							let flag = row.expireTime > new Date().getTime();
							if (row.orderStates == 1 || (row.orderStates == 0 && flag)) {
								btns.push({
									label: "取消订单",
									type: "warning",
									handler: (row, index) =>
										this.cancelOrder(row, index)
								});
							}
							if (row.orderState == 1) {
								btns.push({
									label: "发货",
									type: "success",
									handler: (row, index) =>
										this.toShipping(row, index)
								});
							}

							if (row.orderState == 2) {
								btns.push({
									label: "确认收货",
									type: "success",
									handler: (row, index) =>
										this.toConfirmRecieve(row, index)
								});
							}

							return btns;
						}
					},
					{
						key: "createTime",
						width: 130,
						title: "下单时间",
						render: (h, {
							row
						}) => {
							return h(
								"span",
								this.$util.dateUtil.formatTime(
									row.createTime,
									"Y-M-D h:m"
								)
							);
						}
					},

					{
						key: "orderNo",
						width: 130,
						title: "订单号",
						width: '180px',
					},
					{
						key: "orderState",
						width: 100,
						title: "订单状态",
						render: (h, {
							row
						}) => {
							return h("span", this.filterorderStates(row.orderState, row.expireTime, row
								.reviewerState))
						}
					},
					// {
					//     // 这个要不要作为查询条件
					//     title:'退款状态',
					//     key:'reviewerState',
					//     width:130,
					//     render:(h, { row })=>{
					//        return h("span",this.filterReViewerState(row.reviewerState)) 
					//     }
					// },

					{
						title: "产品主图",
						width: 80,
						imgProps: "goodsImg",
						viewImg: true,
						handler: row => this.argImg(row)
					},
					{
						title: "商品名称",
						width: 140,
						key: "goodsName"
					},
					{
						title: "商品件数",
						width: 140,
						key: "goodsNumber"
					},
					{
						title: "支付金额（￥）",
						width: 110,
						key: "totalPay"
					},
					{
						title: "支付积分",
						width: 75,
						key: "scoreValue"
					},
					// {
					//     title: "所属用户",
					//     width: 140,
					//     key:"name"
					// },
					{
						title: "所属用户电话",
						width: 100,
						key: "contactPhone"
					},
					{
						title: "收货人",
						width: 100,
						key: "contactSubject"
					},
					{
						title: "联系方式",
						width: 100,
						key: "contactPhone"
					},
					{
						title: "收货地址",
						width: 140,
						key: "fullAddress"
					},
					{
						title: "快递公司",
						width: 90,
						key: "logisticsCompany"
					},
					{
						title: "快递单号",
						width: 140,
						key: "logisticsNumber"
					},
					{
						title: "审核时间",
						width: 140,
						key: "expireTime",
						render: (h, {
							row
						}) => {
							return h(
								"span",
								this.$util.dateUtil.formatTime(
									row.expireTime,
									"Y-M-D h:m"
								)
							);
						}

					},
					// {
					// 	title: "审核不通过原因",
					// 	key: "refuseReason",
					// 	width: "200"
					// },
					// {
					// 	title: "取消订单/退款原因",
					// 	key: "cancelReason",
					// 	width: "200"
					// },
				],
				dataList: [],
				selectedList: [],
				curAssignInfo: {
					id: "",
					lockVersion: ""
				},
				cityCode: null, // 业主所在城市的编码

				// 指派人员 [1]
				dialogVisible: false,
				dialogTogglePage: false,
				dialogLoading: false,
				dialogSearchParams: {
					// isAudit: 1,
					// userType: 2,
					//修改之后的参数变化
					userType: 1,
					authState: "APPROVE"
				},
				dialogPageConfig: {
					total: 0,
					pageSize: 100,
					currentPage: 1
				},
				dialogFormOptions: [{
					label: "认证人员",
					prop: "name",
					element: "el-input"
				}],
				dialogTableColumns: [{
						type: "selection",
						fixed: "left"
					},
					{
						key: "name",
						title: "姓名"
					},
					{
						key: "phone",
						title: "手机号"
					},
					{
						key: "auditStateDesc",
						title: "当前状态"
					}
					// {
					//     key: "userStatusDesc",
					//     title: "当前状态"
					// }
				],
				dialogDataList: [],
				dialogSelectedList: [],
				previewPath: '', // 用于预览的图片地址
				toggleImg: false, // 是否显示预览图片的组件
				showEditShipping: false, // 显示
				// 物流信息填写
				editShipingForm: {
					logisticsCompanyName: '',
					logisticsOrderNo: '',
				},
				editShipingFormRule: {
					logisticsCompanyName: [{
						required: true,
						message: '请输入物流公司',
						trigger: 'blur'
					}, ],
					logisticsOrderNo: [{
						required: true,
						message: '请输入物流单号',
						trigger: 'blur'
					}, ],
				},
				// 当前操作的数据
				editRow: {},
				showReasonDialog: false, // 是否展示输入取消原因弹窗
				cancelOrderForm: {
					cancelReason: '', // 取消订单的原因
				},
				cancelOrderRule: {
					cancelReason: [{
						required: true,
						message: '取消订单的原因不能为空',
						trigger: 'blur'
					}]
				},
				// 退款审核的相关操作数据
				showRefundAuditDialog: false, // 是否展示退款审核的弹窗
				refundAuditForm: {
					reviewerState: 1, // 默认是通过
					refuseReason: '', // 审核不通过的原因
				},
				refundAuditFormRule: {
					reviewerState: [{
						required: true,
						message: "审核结果不能为空",
						message: "change"
					}, ],
					refuseReason: [{
						required: true,
						message: "审核不通过的原因不能为空",
						message: "change"
					}, ],
				},
			};
		},
		computed: {
			currentUserAddr() {
				return this.$store.state.user.currentUserAddr;
			}
		},
		mounted() {


			// this.formOptions[7].options = onlycityJsonCopy;

			// console.log(this.currentUserAddr, "currentUserAddr");

			// this.orderStatesTypes = this.formOptions[6].options = this.$util.normalUtil.getDictionaryData(
			//     "T003"
			// );
			// this.formOptions[5].options = this.$util.normalUtil.getDictionaryData(
			//     "T010"
			// );
			// 判断用户的身份是否是超级管理员

			// this.$refs.commonSearch.onSearch();
		},

		methods: {
			// 退款审核
			fefundAudit(row) {
				this.editRow = {
					...row
				};
				/* 
				    "id": 1,
				    "reviewerState": 2, //1, "已通过"，2, "未通过"
				    "refuseReason": "商品已发货"
				*/
				this.showRefundAuditDialog = true; // 显示退款审核的弹窗
			},
			// 关闭退款审核的弹窗
			closeRefundAudit() {
				this.showRefundAuditDialog = false;
				this.refundAuditForm = {
					reviewerState: 1,
					refuseReason: '',
				}
			},
			// 提交退款审核的结果
			submitRefundAudit() {
				this.$refs.refundAuditForm.validate((valid) => {
					if (valid) {
						let reviewerState = this.refundAuditForm.reviewerState == 1 ? (this.editRow
							.reviewerState == 0 ? 2 : 3) : 4;
						let data = {
							id: this.editRow.id,
							reviewerState: reviewerState,
							refuseReason: this.refundAuditForm.refuseReason
						}
						this.$server.codeMall.refundAudit(data, (res) => {
							if (res.code == 0) {
								this.$message.success("审核成功")
								this.closeRefundAudit();
								this.$refs.commonSearch.onSearch();
							} else {
								this.$message(res.message)
							}
						})
					}
				})
			},
			// 退款审核状态的枚举
			filterReViewerState(state) {
				let str = '';
				switch (state) {
					case 0:
						str = "取消订单审核中";
						break;
					case 1:
						str = "退货退款审核中";
						break;
					case 2:
						str = "取消订单申请已通过";
						break;
					case 3:
						str = "退货退款申请已通过";
						break;
					case 4:
						str = "申请未通过";
						break;
				}
				return str;
			},
			// 确认收货
			toConfirmRecieve(row) {
				this.editRow = {
					...row
				};
				this.$confirm("是否确认收货?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消"
				}).then(() => {
					this.$server.system.cancelOrder({
						id: row.id,
						logisticsCompanyName: this.editShipingForm.logisticsCompanyName,
						logisticsOrderNo: this.editShipingForm.logisticsOrderNo,
						updateState:3},(res)=>{
						if (res.code == 0) {
							this.$message.success("收货成功")
							this.$refs.commonSearch.onSearch();
						}
					})

					// 先弹出填写取消订单原因的弹窗
					// this.showReasonDialog = true;
				})

			},
			// 关闭物流信息的弹窗
			closeEditShipping() {
				this.showEditShipping = false;
				this.editShipingForm = {
					logisticsCompanyName: '',
					logisticsOrderNo: '',
				}
			},
			// 确认修改物流信息并关闭弹窗
			submitEditShipping() {
				this.$refs.editShipingForm.validate((valid) => {
					if (valid) {
						let data = {
							id: this.editRow.id,
							updateState: 2, // 改成待发货
							logisticsCompanyName: this.editShipingForm.logisticsCompanyName,
							logisticsOrderNo: this.editShipingForm.logisticsOrderNo
						}
						this.$server.system.cancelOrder(data, (res) => {
							if (res.code == 0) {
								this.$message.success('发货成功')
								// 刷新数据
								this.closeEditShipping();
								this.$refs.commonSearch.onSearch();
							} else {
								this.$message(res.message)
							}
						})
					}
				})
			},
			// 发货
			toShipping(row) {
				// if(row.reviewerState == 0 || row.reviewerState == 1){
				//     this.$message.warning("请先进行退款审核")
				//     return 
				// }
				this.editRow = {
					...row
				}
				this.showEditShipping = true;
			},
			// 取消订单
			cancelOrder(row) {
				// 两种状态都是审核中
				if (row.reviewerState == 0 || row.reviewerState == 1) {
					this.$message.warning("请先进行退款审核")
					return
				}
				this.editRow = {
					...row
				};

				this.$confirm("是否确认取消这个订单?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消"
				}).then(() => {
					this.showReasonDialog = true;
				})
			},
			closeCancelReason() {
				this.showReasonDialog = false;
				this.cancelOrderForm = {
					cancelReason: ''
				}
			},
			// 在这里才真正调用取消订单的接口
			submitCancelReason() {
				this.$refs.cancelOrderForm.validate((valid) => {
					if (valid) {
						let data = {
							id: this.editRow.id,
							// 待支付就直接取消，已支付的就退款
							orderStates: this.editRow.orderStates == 0 ? 4 : 5,
							// 这个取消订单的理由不能遗漏
							cancelReason: this.cancelOrderForm.cancelReason
						}
						this.$server.codeMall.cancelOrder(data, (res) => {
							if (res.code == 0) {
								let str = this.editRow.orderStates == 0 ? '取消订单成功' : '取消订单成功,支付的金额将园路返回';
								this.$message.success(str)
								// 刷新数据
								this.$refs.commonSearch.onSearch();
								// 成功之后关闭这个弹窗
								this.closeCancelReason();
							} else {
								this.$message(res.message)
							}
						})
					}
				})
			},

			argImg(src) {
				let img = src.split(",")[0];
				this.previewPath = img;
				this.toggleImg = true;
			},
			filterorderStates(status, expireTime, reviewerState) {
				let str = "";
				let flag = expireTime > new Date().getTime();
				switch (status) {
					case 0:
						str = "待支付";
						break;
					case 1:
						str = "待发货";
						break;
					case 2:
						str = "待收货";
						break;
					case 3:
						str = "已完成";
						break;
					case 4:
						str = "已取消";
						break;
					case 5:
						str = "已退款";
						break;
					case 100:
						str = "已作废";
						break;
					case 101:
						str = "已删除";
						break;
					default:
						str = "订单状态";
						break;
				}
				if (status == 0 && !flag) {
					str = '超时未支付'
				}
				// // 表示做了退货的操作
				// if(reviewerState !== null){
				//     switch(reviewerState){
				//         case 0 : str = '退款审核中';break;
				//         case 1 : str = '已退款';break;
				//         case 2 : str = '退款失败，将正常发货';break;
				//     }
				// }
				return str;
			},
			// 深拷贝
			deepClone(origin, target) {
				var target = target || {},
					toString = Object.prototype.toString,
					arrType = "[object Array]";
				for (var prop in origin) {
					if (origin.hasOwnProperty(prop)) {
						//<-避免拿到原型链上的属性
						if (
							origin[prop] !== "null" &&
							typeof origin[prop] == "object"
						) {
							target[prop] =
								toString.call(origin[prop]) == arrType ? [] : {};
							this.deepClone(origin[prop], target[prop]);
						} else {
							target[prop] = origin[prop]; //<-原始值直接赋值进行深克隆
						}
					}
				}
				return target;
			},
			saveAssign() {
				if (this.dialogSelectedList.length === 0) {
					return this.$message({
						message: "请先选择需要指派的认证人员",
						center: true,
						type: "error"
					});
				}

				if (this.dialogSelectedList.length > 1) {
					return this.$message({
						message: "只能选择一个认证人员进行指派",
						center: true,
						type: "error"
					});
				}

				this.$server.business.assignOrder({
						// 2021-05-24  增加字段 assignId
						orderId: this.curAssignInfo.id,
						// serverId: this.dialogSelectedList[0].id,
						assignId: this.dialogSelectedList[0].id,
						lockVersion: this.curAssignInfo.lockVersion
					},
					res => {
						this.$message({
							message: "指派成功",
							center: true,
							type: "success"
						});
						this.dialogVisible = false;
						this.searchList(true);
					}
				);
			},
			onDialogSearch(val) {
				val = Object.assign({}, val);
				this.dialogSearchParams = Object.assign({},
					this.dialogSearchParams,
					val
				);
				this.dialogSearchList(true);
			},
			dialogSearchList(flag) {
				let pages = {};
				pages.size = this.dialogPageConfig.pageSize;
				pages.current = this.dialogPageConfig.currentPage;
				if (flag) pages.current = 1;
				let searchParams = this.dialogSearchParams;
				searchParams.cityCode = this.cityCode;
				Object.assign(searchParams, pages);
				this.dialogLoading = true;

				this.$server.business.getAssignUsersData(searchParams, res => {
					this.dialogDataList = res.data.records;
					this.dialogPageConfig.total = res.data.total;
					this.dialogPageConfig.currentPage = res.data.current;
					if (res.data.total > 0) {
						this.dialogTogglePage = true;
					}
					this.dialogLoading = false;
				});
			},
			dialogSelectionChange(val) {
				this.dialogSelectedList = val;
			},
			dialogSizeChange(size) {
				this.dialogPageConfig.currentPage = 1;
				this.dialogPageConfig.pageSize = size;
				this.dialogSearchList();
			},

			dialogCurrentChange(currentPage) {
				this.dialogPageConfig.currentPage = currentPage;
				this.dialogSearchList(true);
			},
			selectionChange(val) {
				this.selectedList = val;
			},
			comonExport() {
				// 参数与列表一致
				let sendData = {
					startCreateTime: this.searchParams.startCreateTime,
					endCreateTime: this.searchParams.endCreateTime,
					orderStates: this.searchParams.orderStates,
					phone: this.searchParams.phone,
					contactSubject: this.searchParams.contactSubject,
					contactPhone: this.searchParams.contactPhone,
					size: this.pageConfig.pageSize,
					current: this.pageConfig.currentPage,
				}
				// 导出  score-order/order-export
				this.$server.common.exportTable(
					`/score-order/order-export`,
					sendData,
					res => {
						console.log("导出成功");
					},
				);
			},
			orderAssign({
				id,
				lockVersion,
				cityCode
			}) {
				// 指派
				this.cityCode = cityCode;
				(this.curAssignInfo.id = id),
				(this.curAssignInfo.lockVersion = lockVersion);
				this.$refs.dialogSearch && this.$refs.dialogSearch.onReset();
				this.dialogSearchList(true);
				this.dialogVisible = true;
			},
			sizeChange(size) {
				this.pageConfig.currentPage = 1;
				this.pageConfig.pageSize = size;
				this.searchList();
			},

			currentChange(currentPage) {
				this.pageConfig.currentPage = currentPage;
				this.searchList();
			},
			onSearch(val) {
				// val = Object.assign({}, val);
				// // 可以选 省/市/区 --- 根据选择对的不通过给不同的字段传值
				// if (val.cityCode && val.cityCode.length == 1) {
				//     val.provinceCode = val.cityCode[0];
				// }
				// if (val.cityCode && val.cityCode.length == 2) {
				//     val.cityCode = val.cityCode[1];
				// }
				// if (val.cityCode && val.cityCode.length == 3) {
				//     val.areaCode = val.cityCode[0];
				// }

				/// 下单时间处理
				val.startCreateTime = val.createTimeArr ?
					val.createTimeArr[0] :
					null;
				val.endCreateTime = val.createTimeArr ? val.createTimeArr[1] : null;
				// if (val.cityCode && typeof val.cityCode == "object") {
				//     delete val.cityCode;
				// }
				this.searchParams = Object.assign({}, val);
				this.searchList(true);
			},
			searchList(flag) {
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage;
				if (flag) pages.current = 1;
				let orderStates = [];
				if (this.searchParams.orderStates) {
					orderStates.push(this.searchParams.orderStates)
				}

				// 要删除 createArr 这个参数
				let searchParams = {
					startCreateTime: this.searchParams.startCreateTime,
					endCreateTime: this.searchParams.endCreateTime,
					orderNo: this.searchParams.orderNo,
					orderStates: orderStates,
				}
				Object.assign(searchParams, pages);
				this.loading = true;
				this.$server.system.productOrder(searchParams, res => {
					this.dataList = res.data.records;
					this.pageConfig.total = res.data.total;
					this.pageConfig.currentPage = res.data.current;
					if (res.data.total > 0) {
						this.togglePage = true;
					}
					this.loading = false;
				});
			}
		}
	};
</script>
<style scoped lang="scss"></style>
